function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_1_)",
  d: "M174,233.9c0,0,1.1-18.2-11.8-23.6c-12.9-5.4-18.2-8.6-20.4-5.4s6.4,25.7,13.9,28.9 S169.7,242.5,174,233.9z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_2_)",
  d: "M191,206.2c0,0,9-9,11,4s-6,37-15,28S187,209.2,191,206.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0A5B4F",
  d: "M202,261.2c0,0-4,1-5,3s-9,5-9-2s3-9,7-9S202,261.2,202,261.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#0A5148",
  d: "M194,215.2l-3.2,17.9c-1.1,6-2.1,11.9-3.1,17.9c-1,6-1.9,12-2.5,18c-0.2,1.5-0.4,3-0.5,4.5 c-0.1,1.5-0.3,3-0.4,4.5c-0.1,1.5-0.2,3-0.3,4.5c0,1.5,0,3-0.1,4.6c-0.9-6-0.7-12.2-0.4-18.3c0.2-3.1,0.5-6.1,0.8-9.1 c0.4-3,0.8-6,1.3-9.1c0.5-3,1-6,1.6-9c0.6-3,1.2-6,1.9-8.9C190.6,226.9,192.2,221,194,215.2z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#0A5148",
  d: "M156,217.2c4.4,2.9,8.4,6.5,11.9,10.4c3.6,3.9,6.8,8.2,9.4,12.9c2.6,4.6,4.7,9.6,5.9,14.8 c1.3,5.2,1.6,10.6,1,15.8c-0.3-5.3-1-10.4-2.6-15.4c-0.3-1.2-0.8-2.5-1.2-3.7c-0.5-1.2-0.9-2.4-1.5-3.6c-1-2.4-2.2-4.7-3.5-6.9 c-2.5-4.5-5.5-8.8-8.8-12.8C163.5,224.6,159.9,220.8,156,217.2z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#0A5148",
  d: "M199,257.2c-3.1,3.2-6,6.3-8.6,9.7l-1,1.3l-0.9,1.3c-0.6,0.9-1.2,1.8-1.7,2.7c-1.1,1.8-2,3.7-3,5.8 c0.1-2.2,0.7-4.4,1.6-6.5c0.9-2,2-4,3.4-5.8c1.4-1.7,2.9-3.4,4.6-4.8C195.2,259.4,197,258.1,199,257.2z"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_3_)",
  d: "M211,265.3c0,0,5.1-7.9-1.9-11c-7-3.1-15-3.2-18-0.2c0,0,9,2.1,10.9,7.1 C203.9,266.2,207.9,268.3,211,265.3z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_4_)",
  d: "M339,281.1c0,0-14.5-11.3-4.5-28.3s32-29,34-25s-5,14-7,18s-8,27-15,31S339,281.1,339,281.1z"
});

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#09494C",
  d: "M337.5,292.8c-0.2-4.7,0.1-9.5,0.8-14.2c0.6-4.7,1.7-9.4,3.1-13.9c0.7-2.3,1.5-4.5,2.5-6.7 c1-2.2,2-4.4,3.3-6.4c1.3-2,2.8-4,4.5-5.7c1.7-1.7,3.7-3.2,5.9-4.1c-3.7,3-6.2,6.9-8.3,10.9c-1,2.1-1.9,4.2-2.7,6.3 c-0.8,2.1-1.6,4.3-2.3,6.5c-0.7,2.2-1.3,4.4-1.9,6.7c-0.6,2.2-1.1,4.5-1.7,6.8C339.5,283.6,338.5,288.2,337.5,292.8z"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M159.1,286c10.8-0.2,21.6-0.3,32.5-0.4l32.5-0.1l32.5,0.1l16.2,0.1L289,286l-16.2,0.2l-16.2,0.1l-32.5,0.1l-32.5-0.1 C180.8,286.3,169.9,286.2,159.1,286z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M319,286c3.5-0.2,7-0.3,10.5-0.4c3.5-0.1,7-0.1,10.5-0.1c3.5,0,7,0,10.5,0.1l5.3,0.1c1.8,0.1,3.5,0.1,5.3,0.2 c-1.8,0.1-3.5,0.2-5.3,0.2l-5.3,0.1c-3.5,0.1-7,0.1-10.5,0.1c-3.5,0-7,0-10.5-0.1C326,286.3,322.5,286.2,319,286z"
});

var _ref13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cloud-svg",
  fill: "#E4EDF4",
  opacity: 0.52,
  d: "M382.8,105.6c2.4,3.9,7,5.8,11.5,5.1c15.6-2.5,60.3-9,89.8-6.6c36.3,2.8,100.2,2.9,108.6-5.1 c6-5.7-11.2-24.6-37.9-15.5c-16,5.5-3.8-19.3-13-36.3C532.7,30,467.6,24,477.7,63.8c5,19.7-53.5-12.3-55.9,5.7 c-2,14.8,19.3,8.2,13.6,14.8C430.2,90.3,372.5,89.2,382.8,105.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cloud-svg",
  fill: "#E4EDF4",
  opacity: 0.52,
  d: "M88.8,1.1c15.2-4.6,31.1,6.2,31.7,22.1c0.1,2.3-0.2,4.4-0.9,6c-2.4,5.4,13.6-8.8,28.4-8.8 c8.3,0,15.3,25.1,2.6,28.6c-11.5,3.2-45.5-6.8-67.8-5c-27.4,2.1-75.6,2.2-81.9-3.9c-4.5-4.3,8.5-18.5,28.6-11.7 c10.4,3.5-11.4-4.8,3-14.9C46,4,59.9,9.7,73.2,5.7L88.8,1.1z"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.13
}, /*#__PURE__*/React.createElement("line", {
  fill: "#9B9B9B",
  x1: 78.9,
  y1: 297.7,
  x2: 514.9,
  y2: 297.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.9,297.7c18.2-1.8,36.3-3.1,54.5-4.2c18.2-1.1,36.3-1.9,54.5-2.5c36.3-1.2,72.7-1.8,109-1.8c36.3,0,72.7,0.6,109,1.8 c18.2,0.6,36.3,1.4,54.5,2.5c9.1,0.5,18.2,1.1,27.3,1.8c9.1,0.7,18.2,1.4,27.3,2.4c-9.1,0.9-18.2,1.7-27.3,2.4 c-9.1,0.7-18.2,1.3-27.3,1.8c-18.2,1.1-36.3,1.9-54.5,2.5c-36.3,1.2-72.7,1.8-109,1.8c-36.3,0-72.7-0.6-109-1.8 c-18.2-0.6-36.3-1.4-54.5-2.5C115.3,300.8,97.1,299.5,78.9,297.7z"
}));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#8E5E3D",
  d: "M251,149.2c0,0,3.7-4.4,3.7-6.1s4,1.9,4,1.9l-5,8.8C253.7,153.8,250.6,150.2,251,149.2z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M262.5,136.4c0-0.7,0.4-2.4-0.3-2.5l-5.2-0.8c0.5-0.7,1.2-1.8,0.1-2l-3.7-0.8c-0.7-0.1-1.3,0.4-1.2,1.1 c0,0.3,0.1,0.7,0.2,1l-1.2-0.2c-1.2-0.1,0.1,6.6,0.6,9.2c0.1,0.6-0.5,1,0.1,1.1l10,1.4c0.9,0.1,1.6-0.5,1.6-1.4L262.5,136.4z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_5_)",
  d: "M246.1,155.8c0,0-2.1-5.4,0-5.4c2.1,0,7.2,1,8.3-2.1s-2.1-20.7-2.1-20.7l-17.6,9.3 c0,0,2.9,15.6-1.4,17.6C231.2,155.6,240.9,152.7,246.1,155.8z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M235.2,146.9c0.9-0.3,1.4-1.2,1.2-2.1c-0.5-1.8-1-4.8,0.4-4.8c2.1,0,2.1,4.1,3.1,3.1c1-1,4.1-3.1,4.1-6.2 s13.4-4.1,8.3-10.3c-5.2-6.2-4.1-8.3-11.4-8.3c-7.2,0-12.4,2.1-14.5,5.2c-2.1,3.1-4.1,13.4,0,14.5 C230.3,139,228.8,148.9,235.2,146.9z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M223.6,123.9c-0.1-0.7-0.7-0.7-1.4-0.6c-3.8,0.3-12.5,7.1-10.1,15.2c1.7,5.8,3.3,8.8,2.6,11.2c-0.3,1.1-2.6,4.2-1.7,4.1 c2.7-0.5,7.7-4.5,8.3-8.6c1-7.2-3.1-17.6,1-18.6C222.3,126.6,224,127.5,223.6,123.9z"
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#0E8778",
  points: "225.8,124.7 223.6,124.3 222.3,126.6 224.6,128.3  "
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_6_)",
  d: "M262.5,150.2c0,0-1.1-2,0-5c1.1-3,4.7-5.1,1.4-7c-3.3-2-4.9,4.7-8.5,4.8c-3.6,0.2-1.4,3.2,0.8,3.2 c2.2,0,3.1,11.6,3.1,11.6S263.6,154.2,262.5,150.2z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#9B4708",
  d: "M245.1,156.6l5.7-7c0.7-0.9,2-0.9,2.8-0.1l0.8,0.8c0.6,0.6,0.7,1.4,0.4,2.2l-2.9,5.8c-0.3,0.7-1,1.1-1.7,1 C248.1,159.2,244.7,158.7,245.1,156.6"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#1E0D01",
  d: "M242,340.3v1c0,1.2,0.9,2.3,2,2.3h4.7c1.1,0,2-1,2-2.3v-1.8c0-1.4-1.1-2.4-2.3-2.2l-4.7,0.8 C242.7,338.2,242,339.2,242,340.3z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#1E0D01",
  d: "M224.7,339.3l0,1.7c0,1.4,1.1,2.4,2.3,2.1l5.1-1.1c1-0.2,1.7-1.3,1.6-2.5l-0.3-2 c-0.2-1.3-1.3-2.1-2.4-1.8l-4.8,1.4C225.3,337.4,224.7,338.3,224.7,339.3z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_7_)",
  d: "M266.1,241c0,0-4.6,16.3-6.9,22.1c-2.2,5.9-1.8,31.5-2,32.4c-0.2,0.9-3.7,23.3-3.3,26.1 c0.4,2.8-10.1,5.9-10.6,2.8c-0.6-3-4.4-31.3,0-44.2c4.4-12.8-1-45.9-0.4-49.8c0,0,3.3,17.8-1.7,34.2c-5,16.3-3.3,26.3-4.3,33.1 c-1,6.7-1,20.7-1,23.5s-9.3,1.1-9.3,1.1s-4.4-39.6,0-57.2s3.3-21.8,4.8-37S267.9,213,266.1,241z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fill: "#3D1900",
  d: "M264.6,327.7c0,0,4.1,3.1,0.6,7c-3.5,3.9-9.3,3.8-12.4,6.2c-2.2,1.7-6.8,1-9.2,0.4 c-0.9-0.2-1.6-1.1-1.6-2.2V324c0-1.1,0.7-2.1,1.7-2.2l8.9-1.2c1.1-0.2,2.1,0.8,2.2,2c0.1,1.5,0.2,3.5-0.3,4.7 C253.8,329.4,260.5,326.2,264.6,327.7z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fill: "#3D1900",
  d: "M237.4,320.3c0.2-0.8-0.5-1.6-1.2-1.4c-3.2,0.9-8,2.5-9.3,1.4c-1.4-1.2-1.9,12.6-2.1,18.4 c-0.1,1.8,0.5,2.7,2.1,2.5c2-0.2,6.9-1.8,10.3-4.2c1.2-0.9,2.6-1.5,4-2l4.3-1.5c0,0,2.4-6.7-7.9-9.4 C237.5,324.2,237,322.3,237.4,320.3z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fill: "#9B4708",
  d: "M262.1,151.1c0.5-0.4,1.2-0.3,1.5,0.2c3.3,5,18.1,27.9,16.5,32.5c-1.7,5.2-18-20.6-20.6-24.9 C257.7,155.7,260.6,152.5,262.1,151.1z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_8_)",
  d: "M233.6,153.2c2.5-1.1,7.1-2.3,12.4-0.1c1.1,0.5,1.7,1.7,1.4,2.9c-0.2,1-0.2,2,0.6,2.5 c1.7,0.9,11.7-2.9,31.6,21.3c0,0,6.2,16.5-16.1,0.2c0,0-2.6,8.6,0,18c2.6,9.4,18,41.2,10.3,41.2c-7.7,0-55.8,4.3-52.4,0 c2.5-3.1,3-43.8,8.1-67.5c1.6-7.3,2.2-12.9,2.3-15.8C231.8,154.7,232.5,153.6,233.6,153.2z"
});

var _ref30 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#B3B9BC",
  points: "250.6,205.7 263.9,199.4 266.2,205.7 253,211.7  "
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9D1D6",
  d: "M254.6,159.3l-14.3,13.5c0,0,26.8,50.1,4.1,50.1s-30.9,6.1-28.2-7.3s2.2-38.1,6.8-39.9 c4.5-1.8,8.1-12.8,8.1-12.8l0.1,1.6l-2.1,9l8.5-1.5l14.1-13.5L254.6,159.3z"
});

var SvgPhotography = function SvgPhotography(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 593.9 377.8",
    enableBackground: "new 0 0 593.9 377.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "translateX(-20px)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.5229,
    y1: 221.1095,
    x2: 174.0434,
    y2: 221.1095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0E8778"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E6D78"
    }
  })), _ref2, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.157,
    y1: 221.6892,
    x2: 202.3326,
    y2: 221.6892
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0E8778"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E6D78"
    }
  })), _ref3, _ref4, _ref5, _ref6, _ref7, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.0843,
    y1: 259.3159,
    x2: 212.7497,
    y2: 259.3159
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0E8778"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E6D78"
    }
  })), _ref8), /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "translateX(-20px)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.7916,
    y1: 262.7116,
    x2: 368.925,
    y2: 244.3781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0E8778"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E7178"
    }
  })), _ref9, _ref10), /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "translateX(-20px)"
    }
  }, _ref11), /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "translateX(-20px)"
    }
  }, _ref12), _ref13), /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "translateX(-30px)"
    }
  }, _ref14, /*#__PURE__*/React.createElement("g", null, _ref15, _ref16, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.9863,
    y1: 141.7604,
    x2: 254.5735,
    y2: 141.7604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF734A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#785636"
    }
  })), _ref17, _ref18, _ref19, _ref20), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.4541,
    y1: 147.7735,
    x2: 265.2529,
    y2: 147.7735
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF734A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#785636"
    }
  })), _ref21, _ref22, /*#__PURE__*/React.createElement("g", null, _ref23, _ref24, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.3348,
    y1: 314.8435,
    x2: 249.4546,
    y2: 242.9113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0E8778"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E6D78"
    }
  })), _ref25, _ref26, _ref27), _ref28, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.2469,
    y1: 196.4639,
    x2: 280.4153,
    y2: 196.4639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC5C00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A64500"
    }
  })), _ref29, _ref30, _ref31)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhotography, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photography.638a8920.svg";
export { ForwardRef as ReactComponent };